export default {
    scaleUpHeading: 'What should happen to the recorded Scale-Up?',
    scaleUpHelp: 'Save the agreed allotments for use before the original contract expires. This does not issue a refund.',
    saveScaleUp: 'Save Scale-Up for a future shoot',
    discardScaleUp: 'Do not save Scale-Up',
    savedQuantity: 'Allotments to save',
    decreaseSavedQuantity: 'Decrease saved allotments',
    increaseSavedQuantity: 'Increase saved allotments',
    paymentAttestation: 'I reviewed the original Scale-Up payment evidence and authorize these allotments.',
    dispositionReason: 'Reason for this Scale-Up decision',
    dispositionReasonHelp: 'At least 10 characters.',
    decisionLabel: 'Scale-Up decision',
    savedDecision: 'Saved {count} allotments for a future shoot',
}
